import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#1c1c1c";
function IOST({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path  d="M18.375 8.25v7.5L12 19.5l-6.375-3.75v-7.5L12 4.5zm-6.576 4.055l-.592.35 1.106.647.59-.347 1.573.926-2.348 1.38-4.871-2.84-.02 1.383 4.894 2.842 4.703-2.765-2.756-1.622.555-.327-1.107-.647-.551.326-.772-.455.675-.4-1.107-.647-.673.398-1.315-.774 2.348-1.381 3.246 1.897 1.189-.704-4.438-2.578-4.702 2.766 2.496 1.469-.47.277 1.107.648.467-.276z" /></Svg>;
}
IOST.DefaultColor = DefaultColor;
export default IOST;